export default {
  name: 'AppLoader',
};
